import { SeverityType } from '@shared/enums/SeverityType';

export abstract class Response {

}

export class SuccessResponse<TData> extends Response {
    constructor() {
        super();
    }

    public data: TData;
    public messages: any;
}

export class ErrorResponse extends Response {
    constructor(public error: any) {
        super();
    }
}

export abstract class HttpResponse {

}

export class HttpSuccessResponse<TData> extends HttpResponse {
    constructor() {
        super();
    }

    public data: TData;
    public messages: HttpErrorResponseMessage[];
}

export class HttpErrorResponse extends HttpResponse {
    constructor(public error: any) {
        super();
    }
}
export class HttpErrorResponseMessage {
    public errorCode: string;
    public errorMessage: string;
    public propertyName: string;
    public severity: SeverityType;
}
